@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";
@import "/src/variables/breakpoints";

.stickyHeading {
    // padding-left: 15px;
    // padding-top: 40px;
    top: 0;
    height: 64px;
    // box-shadow: 0 0.5px 0 #b6b6b6;
    padding-left: $space-8;

    @media screen and (min-width: $breakpoint-tablet) {
        box-shadow: none;
        // border-bottom: 1px solid #cfcfcf;
        top: 0;
    }

    position: sticky;
    z-index: $z-index-9;
    background-color: $zv-canvas--Primary-BG-Color;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    // gap: 5px;
    justify-content: space-between;
    align-items: center;

    .backBtn {
        height: 12px;

        @media screen and (min-width: $breakpoint-tablet) {
            cursor: pointer;
        }
    }

    .heading {
        transform: translateX(-28px);
    }
}

.historyItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: $space-4;
    gap: $space-10;

}

.sibeBtn {
    transform: rotate(180deg);
    width: max-content;

    @media screen and (min-width: $breakpoint-tablet) {
        cursor: pointer;
    }
}

.main {
    container-type: inline-size;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    background-color: $zv-canvas--Primary-BG-Color;
    min-height: 100dvh;
    animation: sidebarPageSlideInLTR 340ms cubic-bezier(0.22, 0.61, 0.36, 1) both;


    @media screen and (min-width: $breakpoint-tablet) {
        padding: 0 0.2cqw;
    }

    .scrollContainer {
        // padding-top: 18cqw;
        display: flex;
        flex-direction: column;
        height: 100dvh;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;

        @media screen and (min-width: $breakpoint-tablet) {
            // padding-top: 4cqw;
            height: calc(100dvh - 64px);

        }
    }

    .historyCard,
    .historyBox {
        .titleStyles {
            letter-spacing: 0px;
            color: $zv-text-primary--Black-Variant2;
            font-weight: $font-weight-semibold;
            font-family: $font-primary;
        }

        .title {
            padding-left: $space-20;
            font-size: $font-size-h12;
            @extend .titleStyles;
            margin-bottom: $space-10;
            margin-left: $space-8;

            @media screen and (min-width: $breakpoint-tablet) {
                font-size: $font-size-h11;
                text-transform: none;
                margin-left: 0px;
            }
        }

        .todayContainer {
            display: flex;
            flex-direction: column;

            .swipeToDelete {
                width: 100%;
            }

            .historyBG{
                background-color: $zv-canvas--White;
            }

            .historyDateTitleContainer {
                cursor: pointer;
                width: 100%;
                display: flex;
                background-color: var(--history-item-bg);
                color: $zv-text-primary--Black-Variant1;
                padding: $space-12 $space-20;
                padding-right: 0;
                gap: $space-4;
                height: 100%;
                user-select: none;
                -webkit-user-select: none;
                /* Safari */
                -ms-user-select: none;
                flex-grow: 1;

                /* Internet Explorer/Edge */
                @media screen and (min-width: $breakpoint-tablet) {}

                &:active {
                    background-color: $zv-well--Neutral-Lightest !important;
                    border-radius: $border-radius-lg;
                }

                // Gate :hover to hover-capable pointers (mouse) only — on touch
                // Safari a bare :hover sticks after a tap, leaving the row stuck
                // grey and reading as "first tap did nothing". :active stays
                // ungated so touch still gets press feedback.
                @media (hover: hover) and (pointer: fine) {
                    &:hover {
                        background-color: $zv-well--Neutral-Lightest !important;
                        border-radius: $border-radius-lg;
                    }
                }

                // The conversation most recently opened from this list.
                &.historySelected {
                    background-color: $zv-highlight--Neutral-Lightest;
                    border-radius: $border-radius-lg;
                }

            }

            .date {
                font-family: $font-primary;
                font-size: 3cqw;
                color: $zv-text-secondary--Neutral;
                user-select: none;
                -webkit-user-select: none;
                /* Safari */
                -ms-user-select: none;
                /* Internet Explorer/Edge */
            }
        }
    }

    .divider {
        display: none;

        @media screen and (max-width: $breakpoint-mobile-max) {
            border-bottom: $border-width solid $zv-border--gray-59;
            width: 90%;
        }
    }

    .historyBox {
        border-bottom: none;
    }
}

.main::after,
.main::before {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.noData {
    width: 100%;
    text-align: center;
}

.emptyState {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: $space-16;
    width: 100%;
    min-height: calc(100dvh - 64px);
    padding: $space-24 $space-16;
    box-sizing: border-box;
    text-align: center;

    .emptyStateFox {
        width: 96px;
        height: 96px;
        object-fit: contain;
    }

    .emptyStateText {
        color: $zv-text-primary--Neutral-Darker;
        max-width: 320px;
    }
}

@keyframes sidebarPageSlideInLTR {
    0% {
        opacity: 0;
        transform: translateX(-48px);
    }
    100% {
        opacity: 1;
        transform: none;
    }
}

@media (prefers-reduced-motion: reduce) {
    .main {
        animation: none;
    }
}

::-webkit-scrollbar {
    display: none;
}

.loader {
    padding-top: 3cqw;
    padding-bottom: 3cqw;
}

.skeletonContainer {
    display: flex;
    flex-direction: column;
    padding: $space-8 0;
}

.skeletonRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $space-12;
    padding: $space-12 $space-20;
}

.skeletonTextColumn {
    display: flex;
    flex-direction: column;
    gap: $space-8;
    flex: 1;
    min-width: 0;
}